import { X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export function SelectedSkillBadges({ skills, onRemove }: { skills: string[]; onRemove: (name: string) => void }) {
  const { t } = useTranslation("chat");
  if (!skills.length) return null;
  return <div role="group" aria-label={t("composerSkills.selectedGroup")} className="flex w-full min-w-0 flex-wrap items-center gap-1">
    {skills.map((name) => <Button key={name} type="button" size="sm" variant="outline" className="w-full min-w-0 justify-start gap-1 px-2 md:w-auto md:max-w-lg" title={name} aria-label={t("composerSkills.remove", { name })} onClick={() => onRemove(name)}>
      <span className="truncate">{name}</span><X className="size-3.5 shrink-0" aria-hidden="true" />
    </Button>)}
  </div>;
}
